module.exports = __webpack_public_path__ + "static/media/Quizy.5310ecfb.png";